import React, { FC } from 'react';

import { formatTime } from '@/scenarios/legacy-player/components/PlayerSkin/hooks/useFormattedTime';

import { Time } from '../../types/time';

import styles from './styles.module.css';

interface Props {
    time: Time;
}

export const CursorTime: FC<Props> = ({ time }) => (
    <span className={styles.root}>{formatTime(Math.floor(time.visibleTime), 60)[0]}</span>
);
